import { BaseDto } from '../../core';
import { BADGE_TYPE } from '../../shared';

export class BadgeDto extends BaseDto<BadgeDto> {
  badgeType: BADGE_TYPE;
  value?: any;
  started?: Date;
  ended?: Date;
}
